import { useEffect, useMemo, useState } from "react";
import { Input, Select, Spin, Table, Tag, message } from "antd";
import PageLayout from "@layouts/PageLayout";
import { getAllUsers, updateSpecificUser } from "@services/users.service";
import AdminFrame from "./AdminFrame";
import { matchesQuery, PAGE_SIZE } from "./list";
import "./shop.css";

function AdminUsersPage() {
  const [users, setUsers] = useState<any[]>([]);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const resp = await getAllUsers("");
      setUsers(resp?.data?.users || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const filtered = useMemo(
    () =>
      users.filter((user) =>
        matchesQuery(query, [user.first_name, user.last_name, user.email, user.role, user.phone_number]),
      ),
    [users, query],
  );

  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <PageLayout>
      <AdminFrame
        title="Users"
        meta={`${filtered.length} accounts`}
        page={page}
        total={filtered.length}
        onPage={setPage}
        extra={
          <Input.Search
            allowClear
            placeholder="Search name or email"
            onChange={(event) => {
              setQuery(event.target.value);
              setPage(1);
            }}
          />
        }
      >
        <Table
          className="data-table"
          rowKey="id"
          loading={loading}
          dataSource={pageItems}
          locale={{ emptyText: loading ? <Spin /> : query.trim() ? "No users match that search" : "No users yet" }}
          pagination={false}
          scroll={{ x: 720 }}
          columns={[
            { title: "Name", render: (_, user: any) => `${user.first_name} ${user.last_name}` },
            { title: "Email", dataIndex: "email" },
            {
              title: "Role",
              render: (_, user: any) => (
                <Select
                  value={user.role === "admin" ? "superadmin" : user.role || "user"}
                  style={{ width: 220 }}
                  options={[
                    { value: "user", label: "Customer" },
                    { value: "store", label: "Store — shipment status" },
                    { value: "superadmin", label: "Superadmin" },
                  ]}
                  onChange={async (role) => {
                    await updateSpecificUser(user.id, { role });
                    message.success("Role updated");
                    load();
                  }}
                />
              ),
            },
            {
              title: "Status",
              dataIndex: "is_active",
              render: (value) => <Tag color={value ? "green" : "red"}>{value ? "active" : "inactive"}</Tag>,
            },
          ]}
        />
      </AdminFrame>
    </PageLayout>
  );
}

export default AdminUsersPage;
